import { Card, CardContent, Divider, Typography } from "@mui/material";

export default function Panel({ title, children }: { title: string; children: React.ReactNode }) {
    return (
        <Card variant="outlined" sx={{ mt: 2 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>{title}</Typography>
                <Divider sx={{ mb: 2 }} />
                {children}
            </CardContent>
        </Card>
    );
}
